import * as TransitionUtils from './css/TransitionUtils';
import * as PrintUtils from './css/PrintUtils';
export function cls(classNames = '', ...additionalClassNames) {
  let classNamesList = [];
  if (typeof classNames === 'string') {
    classNamesList = [...classNamesList, classNames];
  } else {
    const validClassNames = Object.keys(classNames).filter(key => classNames[key]);
    classNamesList = [...classNamesList, ...validClassNames];
  }
  return [...classNamesList, ...additionalClassNames].join(' ');
}
export const events = {
  transition: TransitionUtils,
  print: PrintUtils
};